// extracted by mini-css-extract-plugin
module.exports = {"Files":"files_Files__1K9Hk","File":"files_File__SWr4b","Name":"files_Name__rWmDO","FilesLanding":"files_FilesLanding__Fukf7"};